<div class="row">
    <div [ngClass]="isAdd ? 'col-sm-6' : 'col-sm-10'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageable]="false"
                    [sortable]="false"
                    [filterable]="false"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem)"><i class="fas fa-pencil-alt"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.employeeGroupMapID)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="opportunityQuestionID" title="ID"></kendo-grid-column>
            <kendo-grid-column field="question" title="Question"></kendo-grid-column>
            <kendo-grid-column field="sortOrder" title="Sort Order"></kendo-grid-column>
            <kendo-grid-column field="retired" title="Retired">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.retired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-2" *ngIf="!isAdd">
        <button class="btn btn-sml btn-secondary" title="Close" tabindex="-1" (click)="close()" *ngIf="!isAdd"><i class="fas fa-times"></i></button>
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isAdd || isEdit">
        <div class="row">
            <div class="col">
                <label class="fw-bold">Question</label>
                <kendo-textarea style="width:100%" class="border-secondary" id="question" name="question"
                                resizable="auto"
                                [(ngModel)]="tableItem.question"
                                [value]="tableItem.question">
                </kendo-textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Sort Order</label>
                <input type="number" class="form-control" [(ngModel)]="tableItem.sortOrder" min="1" step="1" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Retired</label>
                <input type="checkbox" id="retired" name="retired" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.retired" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
